/* istanbul ignore file */
export const ACCEPTED_TRIGGERS = ['button', 'a'];

export const EVENTS = {
    OPEN: 'toggle.open',
    CLOSE: 'toggle.close'
};